import { fetchWithTimeout } from '@noths/polaris-client-utils';

export const requestWithTimeout = async <T>(url: string, timeout = 60000): Promise<T> => {
  const response = await fetchWithTimeout(url, { timeout });

  if (response.status !== 200) {
    throw new Error(`${response.status}: ${await response.text()}`);
  }

  return response.json();
};
